const parseJsonContent = (content) => {
    const elements = [];
    const regex = /(\*\*\{size:(\d+)\}(.*?)\{size:end\}\*\*)|(\*\*(.*?)\*\*)|(\{size:(\d+)\}(.*?)\{size:end\})|(\[([^\]]+)\]\(([^)]+)\))|(\r?\n)/g;

    let lastIndex = 0;
    let match;

    while ((match = regex.exec(content))) {
        // Add text before the current match
        if (lastIndex < match.index) {
            elements.push(<span key={lastIndex}>{content.slice(lastIndex, match.index)}</span>);
        }

        // Handle bold text with custom size
        if (match[1]) {
            elements.push(
                <span key={match.index} style={{ fontWeight: "bold", fontSize: `${match[2]}px` }}>
                    {match[3]}
                </span>
            );
        }
        // Handle regular bold text
        else if (match[5]) {
            elements.push(
                <span key={match.index} style={{ fontWeight: "bold" }}>
                    {match[5]}
                </span>
            );
        }
        // Handle regular font size
        else if (match[7]) {
            elements.push(
                <span key={match.index} style={{ fontSize: `${match[7]}px` }}>
                    {match[8]}
                </span>
            );
        }
        // Handle links [text](url)
        else if (match[10]) {
            elements.push(
                <a key={match.index} href={match[11]} target="_blank" rel="noopener noreferrer">
                    {match[10]}
                </a>
            );
        }
        // Handle new line
        else if (match[12]) {
            elements.push(<br key={match.index} />);
        }

        lastIndex = regex.lastIndex;
    }

    // Add remaining text
    if (lastIndex < content.length) {
        elements.push(<span key={lastIndex}>{content.slice(lastIndex)}</span>);
    }

    return elements;
};

export default parseJsonContent;
